export default "__VITE_ASSET__Cle7_5kn__"